import React, { useEffect } from 'react'
import useScript from 'react-script-hook'
import isStolApp, { DEVICES } from '../../../../modules/is-stolapp'
import useConsentReady from '../../../Sourcepoint/modules/use-consent-ready'
import consoleLogger from '../../../../modules/console-logger'
import usePianoReady from '../../../../modules/usePianoReady'

const Criteo = () => {
  const [consoleLog] = consoleLogger('AdsCriteo')
  const [loading, error] = useScript({ src: 'https://static.criteo.net/js/ld/publishertag.js' })
  const isPianoReady = usePianoReady()
  const isConsentReady = useConsentReady()

  consoleLog('consent ready?', isConsentReady)
  consoleLog('script loading?', loading)
  consoleLog('script error?', error)
  consoleLog('piano ready?', isPianoReady)
  consoleLog('***************')

  useEffect(() => {
    if (!loading && !error && isConsentReady && isPianoReady) {
      if (isStolApp()) {
        const optionsUserAds = {
          deviceid: window.device_native_advertising_identifier || null, // deviceId
          deviceidtype: 'none', // gaid or idfa
        }
        if (isStolApp(DEVICES.android)) {
          optionsUserAds['deviceidtype'] = 'gaid'
        } else if (isStolApp(DEVICES.ios)) {
          optionsUserAds['deviceidtype'] = 'idfa'
        }
        window.top.Criteo.SetUserExt(optionsUserAds)
      }
      consoleLog('window variable', window.top.Criteo)

      window.top.Criteo.RequestBidsOnGoogleTagSlots(
        8449,
        function () {
          window.top.Criteo.SetDFPKeyValueTargeting()
          consoleLog('window variable', window.googletag.pubads().getSlots())
          window.googletag = window.googletag || { cmd: [] }
          window.googletag.cmd.push(function () {
            consoleLog('AD LOAD', '')
            window.googletag.pubads().refresh()
          })
        },
        2000,
      )
    }
  }, [loading, isConsentReady, isPianoReady])

  return true
}

export default Criteo
